import { useState } from 'react';
import { ArrowRight, Eye, EyeOff, LockKeyhole, Mail } from 'lucide-react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { AuthPageFrame } from '../../components/auth/AuthPageFrame';
import { useAuth } from '../../hooks/useAuth';

export function LoginPage() {
  const showcaseVideo = 'https://res.cloudinary.com/ubunifu/video/upload/v1607186910/pexels-rodnae-productions-5923291_jd1rwl.mp4';
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [values, setValues] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  async function onSubmit(event) {
    event.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(values);
      navigate(location.state?.from?.pathname || '/dashboard', { replace: true });
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <AuthPageFrame
      eyebrow="Welcome back"
      title="Pick up where you left off."
      description="Log in to continue running your learning business."
      showcaseVideo={showcaseVideo}
      footer={<><span>New to SmartCampus?</span><Link to="/register">Create your account</Link></>}
    >
      <form className="smart-auth-form" onSubmit={onSubmit}>
        {error ? <div className="smart-auth-alert" role="alert">{error}</div> : null}
        <label className="smart-auth-field" htmlFor="email">
          <span>Email</span>
          <div><Mail size={18} aria-hidden="true" /><input id="email" type="email" autoComplete="email" placeholder="name@example.com" required value={values.email} onChange={(event) => setValues({ ...values, email: event.target.value })} /></div>
        </label>
        <label className="smart-auth-field" htmlFor="password">
          <span>Password</span>
          <div><LockKeyhole size={18} aria-hidden="true" /><input id="password" type={showPassword ? 'text' : 'password'} autoComplete="current-password" placeholder="Enter your password" required value={values.password} onChange={(event) => setValues({ ...values, password: event.target.value })} /><button className="smart-auth-password-toggle" type="button" aria-label={showPassword ? 'Hide password' : 'Show password'} onClick={() => setShowPassword((visible) => !visible)}>{showPassword ? <EyeOff size={18} /> : <Eye size={18} />}</button></div>
        </label>
        <div className="smart-auth-form-options"><label><input type="checkbox" /> Keep me signed in</label><Link to="/forgot-password">Forgot password?</Link></div>
        <button className="smart-auth-submit" type="submit" disabled={loading}>{loading ? 'Logging you in…' : <>Log in <ArrowRight size={19} /></>}</button>
      </form>
    </AuthPageFrame>
  );
}
